import React, { useCallback } from 'react';
import { Card, Button, Header } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { UserChip } from 'components/lib/Chips';
import util from 'utils/utils';
import { InviteCardProps } from './types';
import InviteeChip from './InviteeChip';

const IdeaInviteCard = ({ invitation, acceptInvite, rejectInvite, removeInvite }: InviteCardProps) => {
  const { inviterUser, inviteeUser, invitee, idea, createdByCurrentUser } = invitation;

  const accept = useCallback(() => {
    util.confirm('Join idea team', `Are you sure you want to collaborate with ${inviterUser?.profile?.fullName} on the idea "${idea.name}"?`)
      .then(() => {
        acceptInvite(invitation, () => {
          toast.success('Joined idea team');
        }, () => toast.error('Error joining idea team'));
      })
      .catch(() => {})
  }, [acceptInvite, invitation, idea?.name, inviterUser?.profile?.fullName]);

  const reject = useCallback(() => {
    util.confirm('Reject join', `Are you sure you want to reject ${inviterUser?.profile?.fullName} invitation to join the idea "${idea?.name || 'Deleted idea'}"?`)
      .then(() => {
        rejectInvite(invitation, () => {
          toast('Invitation rejected');
        }, () => toast.error('Error rejecting invite'));
      })
      .catch(() => {})
  }, [rejectInvite, invitation, idea?.name, inviterUser?.profile?.fullName]);

  const remove = useCallback(() => {
    util.confirm('Remove invitation', `Are you sure you want to remove your invitation to let ${inviteeUser?.profile?.fullName || invitee} join your idea "${idea?.name || 'Deleted idea'}"?`)
      .then(() => {
        removeInvite(invitation, () => {
          toast('Invitation removed');
        }, () => toast.error('Error removing invite'));
      })
      .catch(() => {})
  }, [removeInvite, invitation, idea?.name, inviteeUser?.profile?.fullName, invitee]);


  if (!idea) {
    invitation.canAccept = false;
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div>
        <Header as={Link} disabled={!idea} to={idea ? `/ideas/${idea._id}` : null}>{idea?.name || "Deleted idea"}</Header>
        <Card.Description>
          {createdByCurrentUser ? (
            <InviteeChip invitation={invitation} preText='You invited' postText='to join this idea' />
          ) : (
            <UserChip user={inviterUser} noAvatar postText='has invited you to join this idea' />
          )}
        </Card.Description>
      </div>
      <Card.Content extra>
        <div className='ui'>
          {invitation.acceptedAt ? (
              <Button basic color='green' as={Link} disabled={!idea} to={`/ideas/${idea?._id}`}>
                Go to idea
              </Button>
            ) : (
              <>
                {invitation.canAccept ? (
                  <Button basic color='green' onClick={accept}>
                    Accept
                  </Button>
                ) : null}
                {invitation.canRemove ? (
                  <Button basic color={createdByCurrentUser ? null : 'red'} onClick={createdByCurrentUser ? remove : reject}>
                    {createdByCurrentUser ? 'Remove' : 'Reject'}
                  </Button>
                ) : null}
              </>
            )}
        </div>
      </Card.Content>
    </div>
  );
}

export default IdeaInviteCard;
